window.IFrameResizer = (function () {

    var iframeResizerInternal =
    {
        state: {},

        start: function (target, observableSelectors) {
            if (typeof target === 'undefined' || target === null) {
                //console.log("No target provided.");
                return;
            }

            if (typeof observableSelectors === 'undefined'
                || observableSelectors === null
                || observableSelectors.length === 0) {
                //console.log("No selectors provided.");
                return;
            }

            if (Object.prototype.toString.call(target) !== '[object HTMLIFrameElement]') {
                //console.log("target must be an iframe, got: %s", Object.prototype.toString.call(target));
                return;
            }

            if (!Array.isArray(observableSelectors)) {
                //console.log("selectors must be an array, got: %s", Object.prototype.toString.call(selectors));
                return;
            }

            //disconnect existing observer if somebody calls init twice
            if (Object.prototype.toString.call(this.state.observer) === '[object ResizeObserver]') {
                this.state.observer.disconnect();
            }

            var totalHeight = document.body.offsetHeight;
            var unobservedHeight = totalHeight;

            //only want unique elements, in case some selectors produce overlapping results, otherwise height would be duplicated
            var elementsSet = new Set();
            observableSelectors.forEach(function (selector) {
                try {
                    var elements = document.querySelectorAll(String(selector));

                    for (var i = 0; i < elements.length; i++) {
                        if (!elementsSet.has(elements[i])) {
                            elementsSet.add(elements[i]);
                            unobservedHeight -= elements[i].offsetHeight;
                        }
                    }
                } catch (err) { } //don't care if it's not a valid selector
            }, this);

            //selectors produced no results, we can just return
            if (elementsSet.size === 0) {
                return;
            }

            this.state = {
                iframe: target,
                observer: new ResizeObserver(this.dimensionsChanged),
                observedElements: elementsSet,
                unobservedHeight: unobservedHeight
            };

            this.state.observedElements.forEach(function (observedElement) {
                this.state.observer.observe(observedElement);
            }, this);
        },

        stop: function () {
            if (Object.prototype.toString.call(this.state.observer) === '[object ResizeObserver]') {
                this.state.observer.disconnect();
            }
        },

        dimensionsChanged: function (entries) {
            var newHeight = this.state.unobservedHeight;

            //convert to a map for faster lookup, O(n) for all entries to convert, then O(1) for each lookup
            var entriesMap = new Map();
            entries.forEach(function (entry) {
                entriesMap.set(entry.target, entry);
            });

            this.state.observedElements.forEach(function (observedElement) {
                var entry = entriesMap.get(observedElement);
                if (entry === undefined) {
                    newHeight += observedElement.offsetHeight;
                } else {
                    //firefox gives a simple object, chrome/chromium gives an array
                    var contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
                    newHeight += contentBoxSize.blockSize;
                }
            });

            this.state.iframe.style.height = newHeight + "px";
        }
    };

    iframeResizerInternal.dimensionsChanged = iframeResizerInternal.dimensionsChanged.bind(iframeResizerInternal);

    return iframeResizerInternal;
})();
